

<div>
   <p-skeleton width="100%" height="300px"></p-skeleton>
</div>